(function () {
  if (window.__discountCodeFieldLoaded) return;
  window.__discountCodeFieldLoaded = true;

  function currentPath() {
    return window.location.pathname + window.location.search;
  }

  function applyDiscountCode(input, messageEl) {
    var code = (input.value || '').trim();

    if (!code) {
      if (messageEl) messageEl.textContent = 'Enter a discount code.';
      input.focus();
      return;
    }

    if (messageEl) messageEl.textContent = 'Applying…';

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var base = root.replace(/\/$/, '');
    var redirectTo = currentPath() || '/cart';

    window.location.href =
      base + '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(redirectTo);
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-discount-code-apply]');
    if (!trigger) return;

    var inputId = trigger.getAttribute('data-discount-code-input');
    var input = inputId && document.getElementById(inputId);
    if (!input) return;

    var wrapper = trigger.closest('[data-discount-code-field]');
    var messageEl = wrapper && wrapper.querySelector('[data-discount-code-message]');

    applyDiscountCode(input, messageEl);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;

    var input = event.target.closest('[data-discount-code-input-field]');
    if (!input) return;

    event.preventDefault();

    var wrapper = input.closest('[data-discount-code-field]');
    var messageEl = wrapper && wrapper.querySelector('[data-discount-code-message]');

    applyDiscountCode(input, messageEl);
  });
})();
